import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useDarkMode } from '../../context/DarkModeContext';
import { useExperiment } from '../../context/ExperimentContext';
import { LogOut, Plus, Clipboard, User, Award, Shield, Bell, Moon, Sun } from 'react-feather';
import { Notifications } from './Notifications';

export const Header = () => {
  const { user, profile, logOut, isTeacher } = useAuth();
  const { isDark, toggleDarkMode } = useDarkMode();
  const { isPointsEnabled } = useExperiment();
  const navigate = useNavigate();

  return (
    <header className="app-header">
      <div className="header-content">
        <Link to="/" className="logo">🎓 PeerTutor</Link>
        {user && (
          <div className="user-menu">
            <button onClick={toggleDarkMode} className="nav-btn">{isDark ? <Sun size={18} /> : <Moon size={18} />}</button>
            <Notifications />
            {isTeacher && <Link to="/teacher-dashboard" className="nav-btn"><Shield size={18} /></Link>}
            <Link to="/leaderboard" className="nav-btn"><Award size={18} /></Link>
            <Link to="/my-requests" className="nav-btn"><Clipboard size={18} /></Link>
            <Link to={`/profile/${user.uid}`} className="nav-btn"><User size={18} /></Link>
            <Link to="/post-request" className="post-btn"><Plus size={18} /></Link>
            <span className="user-info">{profile?.displayName || user.email.split('@')[0]}{isTeacher && <span className="teacher-badge">Teacher</span>}</span>
            {isPointsEnabled && <span className="points-badge">⭐ {profile?.points || 0} pts</span>}
            <button onClick={async () => { await logOut(); navigate('/login'); }} className="nav-btn"><LogOut size={18} /></button>
          </div>
        )}
      </div>
    </header>
  );
};
